import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../../../services/modal/modal.service';
import { BaseModalComponent } from '../../base-modal.component';
import {
  UseCaseWithMessage,
  UseCaseWithMessageHeader,
  UseCaseWithMessageText,
} from '../../../../classes/UseCaseWithMessage';

@Component({
  moduleId: module.id,
  selector: 'use-cases-with-messages',
  templateUrl: './use-cases-with-messages.component.html',
})
export class UseCasesWithMessageComponent extends BaseModalComponent implements OnInit {
  modalText: Array<string>;
  modalHeader: string;

  constructor(modalService: ModalService) {
    super(modalService);
  }

  ngOnInit() {
    const useCase = UseCaseWithMessage[this.data.useCaseWithMessage];
    this.modalHeader = UseCaseWithMessageHeader[useCase];
    this.modalText = UseCaseWithMessageText[useCase].split('|');
  }

  cancel() {}
  confirm() {
    this.modalService.deactivate();
  }
}
